import React, { useState, useRef } from 'react';
import Link from '../Link';
import { getCtaUrl } from '../../../utils';

import './index.scss';

const DropdownItem = ({ link, label, children, extraClass }) => {
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const mouseEnter = () => setDropdownOpen(true);
  const mouseLeave = () => setDropdownOpen(false);
  const toggleMenu = () => setDropdownOpen(!dropdownOpen);
  const closeDropdown = () => setDropdownOpen(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setDropdownOpen(false);
      buttonRef.current?.focus();
    }
  };

  const handleFocusLost = (e) => {
    if (!menuRef.current.contains(e.relatedTarget)) {
      closeDropdown();
    }
  };

  return (
    <li className="dropdown nav-item" onMouseEnter={mouseEnter} onMouseLeave={mouseLeave} onKeyDown={handleKeyDown}>
      <a
        ref={buttonRef}
        href={'#'}
        className="dropdown-main-link main-link"
        role="button"
        aria-haspopup="true"
        aria-expanded={dropdownOpen}
        onClick={toggleMenu}
      >
        {label}
      </a>

      <ul
        ref={menuRef}
        aria-hidden={!dropdownOpen}
        onBlur={handleFocusLost}
        className={`dropdown-menu ${dropdownOpen ? 'open' : null}`}
      >
        {children
          ?.sort((a, b) => a.position - b.position)
          .map((link) => (
            <li className="dropdown-item" key={link.id}>
              <Link className="dropdown-link" to={getCtaUrl(link)} onClick={closeDropdown}>
                {link?.title}
              </Link>
            </li>
          ))}
      </ul>
    </li>
  );
};

export default DropdownItem;
